module.exports = __webpack_public_path__ + "img/kjicon3.ea0f489b.svg";